import React from 'react';
import PropTypes from 'prop-types';
import ConditionalWrapper from '../../ConditionalWrapper/ConditionalWrapper';

const PropertyDetailsUtilitiesSection = ({ util }) => (
  <ConditionalWrapper condition={!!util}>
    <div>
      { util.supplierName && <li><strong>Supplier:</strong> {util.supplierName}</li> }
      { util.ownership && <li><strong>Ownership:</strong> {util.ownership}</li> }
      { util.contactName && <li><strong>Contact:</strong> {util.contactName}</li> }
      { util.phone && <li><strong>Phone:</strong> {util.phone}</li> }
      { util.website &&
        <li><strong>Website:</strong> <a href={util.website}>{util.website}</a></li>
      }
    </div>
  </ConditionalWrapper>
);

PropertyDetailsUtilitiesSection.propTypes = {
  util: PropTypes.object,
};

export default PropertyDetailsUtilitiesSection;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailUtilitiesSection/PropertyDetailUtilitiesSection.js